import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type SignInPromptReason = "save-job";

export interface AuthPromptState {
  isSignInPromptOpen: boolean;
  /** Which flow triggered the prompt, so the modal can tailor its copy. Defaults to the save-job framing. */
  reason: SignInPromptReason;
}

const initialState: AuthPromptState = {
  isSignInPromptOpen: false,
  reason: "save-job",
};

const authPromptSlice = createSlice({
  name: "authPrompt",
  initialState,
  reducers: {
    openSignInPrompt(state, action: PayloadAction<{ reason?: SignInPromptReason } | undefined>) {
      state.isSignInPromptOpen = true;
      state.reason = action.payload?.reason ?? "save-job";
    },
    closeSignInPrompt(state) {
      state.isSignInPromptOpen = false;
    },
  },
});

export const { openSignInPrompt, closeSignInPrompt } = authPromptSlice.actions;
export const authPromptReducer = authPromptSlice.reducer;
